module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "registerView"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.ds_data.ds_info.fid
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#333333",
      "line-height": "30px",
      "font-size": "20px",
      "font-weight": "bold",
      "padding": "20px 20px 10px 20px",
      "text-align": "left"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.ds_data.ds_info.name) + _vm._s(_vm.ds_data.ds_info.name) + "\n    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "left",
      "padding": "0px 0px 20px 20px",
      "color": "#afafaf"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#007AFF"
    }
  }, [_vm._v(_vm._s(_vm.ds_data.ds_info.create_time))]), _vm._v(" | " + _vm._s(_vm.ds_data.ds_info.view_num) + "人观看\n    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "white",
      "margin-top": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "#333333",
      "padding": "10px 20px 10px 20px",
      "text-align": "left"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.ds_data.picArticl.name) + "\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.ds_data.picArticl.content),
      expression: "ds_data.picArticl.content"
    }]
  }, [_vm._v("\n      " + _vm._s(_vm.ds_data.picArticl.content) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0px",
      "bottom": "0px",
      "position": "fixed",
      "width": "100%"
    }
  }, [(_vm.ds_data.is_check_play == 'yes') ? _c('van-button', {
    attrs: {
      "size": "large",
      "type": "primary",
      "block": ""
    },
    on: {
      "click": _vm.showKey
    }
  }, [_vm._v("登记观看")]) : _c('van-button', {
    attrs: {
      "size": "large",
      "type": "primary",
      "block": ""
    },
    on: {
      "click": _vm.showKey
    }
  }, [_vm._v("进入直播间")])], 1), _vm._v(" "), (_vm.registerIsShow) ? _c('tel-test', {
    attrs: {
      "fans_id": _vm.fans_id,
      "show_type": 1,
      "ds_id": _vm.ds_id,
      "param-data": _vm.keyData
    },
    on: {
      "registerok": _vm.registerok
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ab0426"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/RegisterView.vue
// module id = 372
// module chunks = 0